var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4105_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 27.5C17.4998 27.9584 17.8748 28.3334 18.3332 28.3334H21.6665C22.1248 28.3334 22.4998 27.9584 22.4998 27.5V26.6667H17.4998V27.5ZM19.9998 11.6667C16.7832 11.6667 14.1665 14.2834 14.1665 17.5C14.1665 19.4834 15.1582 21.225 16.6665 22.2834V24.1667C16.6665 24.625 17.0415 25 17.4998 25H22.4998C22.9582 25 23.3332 24.625 23.3332 24.1667V22.2834C24.8415 21.225 25.8332 19.4834 25.8332 17.5C25.8332 14.2834 23.2165 11.6667 19.9998 11.6667ZM21.6665 21.4167V23.3334H18.3332V21.4167C17.0665 20.525 15.8332 19.6084 15.8332 17.5C15.8332 15.2 17.6998 13.3334 19.9998 13.3334C22.2998 13.3334 24.1665 15.2 24.1665 17.5C24.1665 19.575 22.9082 20.5417 21.6665 21.4167Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4105_1200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotIcon);
export default __webpack_public_path__ + "static/media/spot-icon.6c8fd6a0a2be8f90988fd5e138d3e3e0.svg";
export { ForwardRef as ReactComponent };